import React from 'react';
import { Route, Routes } from 'react-router-dom';
import BaseLayout from './layout/Base';
import DashboardPage from './pages/DashboardPage';
import { FundosGerenciadosPage } from './features/fundos_gerenciados';
import { PassivosPage } from './features/passivos';
import {
  FundoInvestimentoPage,
  RendaFixaTituloPublicoPage,
  CompromissadaPage,
  RendaFixaBancarioPage,
  RendaFixaCorporativoPage,
  RendaFixaSecuritizadoPage,
  RendaVariavelPage,
  ADRPage,
  MapeamentoAtivosPage,
} from './features/ativos';
import {
  CarteiraDiariaAtivosPage,
  CarteiraDiariaPassivosPage,
  CarteiraDiariaPLPage,
  CarteiraDiariaTesourariaPage,
  CarteiraDiariaConsultaPage,
} from './features/carteira';
import LoginPage from './pages/LoginPage';
import { PrivateRoute } from './routes/PrivateRoute';
import { UserCRUDPage } from './features/admin';
import { RelatoriosPage, RelatorioPLFundosPage } from './features/relatorios';

const App: React.FC = () => {
  return (
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/" element={<PrivateRoute><BaseLayout><DashboardPage /></BaseLayout></PrivateRoute>} />
        <Route path="/fundos_gerenciados" element={<PrivateRoute><BaseLayout><FundosGerenciadosPage /></BaseLayout></PrivateRoute>} />
        <Route path="/carteira_diaria" element={<PrivateRoute><BaseLayout><CarteiraDiariaConsultaPage /></BaseLayout></PrivateRoute>} />
        <Route path="/carteira_diaria/ativos" element={<PrivateRoute><BaseLayout><CarteiraDiariaAtivosPage /></BaseLayout></PrivateRoute>} />
        <Route path="/carteira_diaria/passivos" element={<PrivateRoute><BaseLayout><CarteiraDiariaPassivosPage /></BaseLayout></PrivateRoute>} />
        <Route path="/carteira_diaria/patrimonio" element={<PrivateRoute><BaseLayout><CarteiraDiariaPLPage /></BaseLayout></PrivateRoute>} />
        <Route path="/carteira_diaria/saldotesouraria" element={<PrivateRoute><BaseLayout><CarteiraDiariaTesourariaPage /></BaseLayout></PrivateRoute>} />
        <Route path="/ativos/fundos_investimento" element={<PrivateRoute><BaseLayout><FundoInvestimentoPage /></BaseLayout></PrivateRoute>} />
        <Route path="/ativos/rendafixa_titulo_publico" element={<PrivateRoute><BaseLayout><RendaFixaTituloPublicoPage /></BaseLayout></PrivateRoute>} />
        <Route path="/ativos/compromissada" element={<PrivateRoute><BaseLayout><CompromissadaPage /></BaseLayout></PrivateRoute>} />
        <Route path="/ativos/rendafixa_bancario" element={<PrivateRoute><BaseLayout><RendaFixaBancarioPage /></BaseLayout></PrivateRoute>} />
        <Route path="/ativos/rendafixa_corporativo" element={<PrivateRoute><BaseLayout><RendaFixaCorporativoPage /></BaseLayout></PrivateRoute>} />
        <Route path="/ativos/rendafixa_securitizado" element={<PrivateRoute><BaseLayout><RendaFixaSecuritizadoPage /></BaseLayout></PrivateRoute>} />
        <Route path="/ativos/renda_variavel" element={<PrivateRoute><BaseLayout><RendaVariavelPage /></BaseLayout></PrivateRoute>} />
        <Route path="/ativos/adr" element={<PrivateRoute><BaseLayout><ADRPage /></BaseLayout></PrivateRoute>} />
        <Route path="/ativos/mapeamento" element={<PrivateRoute><BaseLayout><MapeamentoAtivosPage /></BaseLayout></PrivateRoute>} />
        <Route path="/passivos" element={<PrivateRoute><BaseLayout><PassivosPage /></BaseLayout></PrivateRoute>} />
        <Route path="/config/usuarios" element={<PrivateRoute><BaseLayout><UserCRUDPage /></BaseLayout></PrivateRoute>} />
        <Route path="/relatorios" element={<PrivateRoute><BaseLayout><RelatoriosPage /></BaseLayout></PrivateRoute>} />
        <Route path="/relatorios/pl-fundos" element={<PrivateRoute><BaseLayout><RelatorioPLFundosPage /></BaseLayout></PrivateRoute>} />
      </Routes>
  );
};

export default App;
